import React from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../../Page";
import { FetchListadoEndosos, FetchListadoGeneralEndosos } from "../../../redux/actions/aEndososBeneficiarios";
import CoberturasHogar from "./CoberturasHogar";

class TablaHogar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            datosEndososGenerales: {
                datosEndososGenerales: []
            },
            listado: [],
            filtro: "",
            filtroValor: "",
            first: 0,
            rows: 10,
            totalRecords: 0,
            poliza: "",
            sucursal: "",
            ramo: "",
            paso: "tabla",
            seleccionado: {}
        };
    }

    async componentDidMount() {
        const queryParams = new URLSearchParams(this.props.location.search);
        const poliza = queryParams.get("poliza");
        const sucursal = queryParams.get("sucursal");
        const ramo = queryParams.get("ramo");
        const body = {
            poliza,
            sucursal,
            ramo
        };
        await this.props.listadoEndososGeneralesRamo({
            empCodigo: "AIGMETROPOLITANA",
            ...body
        })
        this.setState(body);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.datosEndosos !== prevProps.datosEndosos) {
            if (this.props.datosEndosos !== undefined &&
                this.props.datosEndosos.datosEndososGenerales !== undefined &&
                Array.isArray(this.props.datosEndosos.datosEndososGenerales)
            ) {
                this.setState({
                    listado: this.props.datosEndosos.datosEndososGenerales,
                    totalRecords: this.props.datosEndosos.datosEndososGenerales.length
                });
            }

        }
    }

    renderDataRamo = () => {
        return (
            <Row style={{ marginLeft: 0 }}>
                <Col>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Póliza:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.poliza}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Sucursal:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.sucursal}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={1} lg={1} md={1}>
                            Ramo:
                        </Col>
                        <Col xl={11} lg={11} md={11}>
                            {this.state.ramo}
                        </Col>
                    </Row>
                </Col>

            </Row>
        )
    }

    renderMensajeCantidad = () => {
        const desde = this.state.totalRecords === 0 ? 0 : this.state.first + 1;
        const hasta = Math.min(this.state.first + this.state.rows, this.state.totalRecords);

        return (
            <Col>
                {`Mostrando ${desde} - ${hasta} de ${this.state.totalRecords} registros`}
            </Col>
        );
    }

    parseoRenderizadoEndoso = (rowData) => {
        const itemAsegurado = [
            {
                "label": "Placa:",
                "value": rowData.placa
            },
            {
                "label": "Modelo:",
                "value": rowData.modelo
            },
            {
                "label": "Chasis:",
                "value": rowData.chasis
            },
            {
                "label": "Año:",
                "value": rowData.anio
            },
            {
                "label": "Motor:",
                "value": rowData.motor
            },
            {
                "label": "Color:",
                "value": rowData.color
            },
            {
                "label": "Marca:",
                "value": rowData.marca
            },
            {
                "label": "Valor asegurado:",
                "value": rowData.sumaAseguradaLabel
            }
        ]
        return {
            data: rowData,
            dataItemAsegurado: itemAsegurado
        }
    }

    onRegresar = () => {
        this.props.history.push({
            pathname: "/polizas-emitidas-vigentes"
        });
    }

    renderTablaHogar = (
        listado, rows,
        first,
        totalRecords
    ) => {
        return (<Page
            title={
                "Items hogar"
            }
        >
            {listado.length > 0 && (
                <div>
                    <Row>
                        <Col xl={12} style={{ marginBottom: "0px" }}>
                            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                <Col>
                                    <Button className={"button-white"} onClick={() => { this.onRegresar() }}>
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                        REGRESAR
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            {this.renderDataRamo()}
                            {this.renderMensajeCantidad()}
                            <Card body>
                                <DataTable
                                    value={listado}
                                    responsive
                                    className="p-datatable-customers"
                                    rowHover
                                    paginator
                                    rowsPerPageOptions={[10, 25, 50]}
                                    emptyMessage="No se han encontrado resultados"
                                    resizableColumns
                                    rows={rows}
                                    first={first}
                                    totalRecords={totalRecords}
                                    onPage={(e) => {
                                        this.setState({
                                            first: e.first,
                                            rows: e.rows
                                        });
                                    }}
                                >
                                    <Column
                                        className="counter"
                                        field="contador"
                                        header="#"
                                        style={{ width: "60px" }}
                                    />
                                    <Column
                                        field="cod_item"
                                        header="Codigo ítem"
                                        sortable
                                        style={{ width: "100px" }}
                                    />
                                    <Column
                                        header="Provincia"
                                        field="provincia"
                                        sortable
                                        style={{ width: "100px" }}
                                    />
                                    <Column
                                        header="Ciudad"
                                        field="ciudad"
                                        sortable
                                        style={{ width: "100px" }}
                                    />
                                    <Column
                                        header="Direccion"
                                        field="direccion"
                                        sortable
                                        style={{ width: "150px" }}
                                    />
                                    <Column
                                        header=""
                                        body={(rowData) => {
                                            return (
                                                <Col style={{ textAlign: "center", margin: "1.5px" }}>
                                                    <Button className={"btn btn-primary"} style={{ margin: "auto" }} onClick={() => {
                                                        this.setState({
                                                            "paso": "coberturas",
                                                            "seleccionado": {
                                                                ...rowData
                                                            }
                                                        })
                                                    }
                                                    }>
                                                        <p style={{ margin: 0 }}>Ver coberturas</p>
                                                    </Button>
                                                </Col>
                                            );
                                        }}
                                        style={{ width: "150px" }}
                                    />
                                </DataTable>
                            </Card>
                        </Col>
                    </Row>
                </div>

            )}

            {listado.length === 0 && (
                <Row>
                    <Col xl={12} style={{ marginBottom: "0px" }}>
                        <Row style={{ marginLeft: 0, marginRight: 0 }}>
                            <Col>
                                <Button className={"button-white"} onClick={() => { this.onRegresar() }}>
                                    <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                    REGRESAR
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="detalle-cotizacion-box"
                    >
                        <Card className="mb-3">
                            <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                            <CardBody>
                                <h2 style={{ color: "#001871", textAlign: "center" }}>
                                    {" "}
                                    NO SE HA ENCONTRADO REGISTROS DE HOGAR ASOCIADOS
                                </h2>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
        </Page>)

    }

    onRegresarCoberturas = () => {
        this.setState({
            paso: "tabla"
        });
    }



    renderTablaCoberturas = () => {
        return (
            <CoberturasHogar
                general={{
                    poliza: this.state.poliza,
                    ramo: this.state.ramo,
                    sucursal: this.state.sucursal,
                    ...this.state.seleccionado
                }}
                funciones={this.props.funciones}
                regresar={this.onRegresarCoberturas}
            />
        )
    }

    render() {
        const {
            listado,
            rows,
            first,
            totalRecords,
            paso
        } = this.state;

        const {
            funciones
        } = this.props;
        return <>
            {paso === 'tabla' && this.renderTablaHogar(
                listado,
                rows,
                first,
                totalRecords)
            }
            {paso === 'coberturas' && this.renderTablaCoberturas(
                listado,
                rows,
                first,
                totalRecords,
                funciones)
            }
        </>
    }
}

const mapStateToProps = (state) => ({
    datosEndosos: state.dataEndosos
});

const mapDispatchToProps = (dispatch) => {
    return {
        listadoEndososGeneralesRamo: (body) => dispatch(FetchListadoGeneralEndosos(body))

    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TablaHogar)
);